// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609301504/js/" + chunkId + "." + {"44":"076095c0","225":"33120d82","481":"401bd0a0","486":"653b7706","770":"25aa3f9f"}[chunkId] + ".0.5205201784068566.chunk.js";
};